<template>
  <div class="page-shell">
    <site-header :company-info="companyInfo" />
    <main>
      <router-view :company-info="companyInfo" />
    </main>
    <site-footer :company-info="companyInfo" />
  </div>
</template>

<script>
import { fetchCompanyInfo } from "../api/public";
import SiteHeader from "../components/SiteHeader.vue";
import SiteFooter from "../components/SiteFooter.vue";

export default {
  name: "PublicLayout",
  components: {
    SiteHeader,
    SiteFooter
  },
  data: function data() {
    return {
      companyInfo: {}
    };
  },
  created: function created() {
    this.loadCompanyInfo();
  },
  methods: {
    async loadCompanyInfo() {
      const response = await fetchCompanyInfo();
      this.companyInfo = response.data;
    }
  }
};
</script>

